import React, { useEffect, useState } from "react";
import BrokerAdminNavigation from "../general/BrokerAdminNavigation";
import GeneralAuthentication from "../general/GeneralAuthentication";
import * as theme from "../theme";
import PerfectScrollbar from "react-perfect-scrollbar";
import WelcomeBackRightPane from "../general/WelcomeBackRightPane";
import getDetailsAdmin from "../store/brokerage";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBrokerInformation, verifyToken } from "../store/broker";
import Select from "react-dropdown-select";
import {
  getBrokeragesList,
  loadBrokerages,
  getSelectedBrokerage,
  brokerageSelected,
} from "../store/brokerages";
import { makeStyles } from "@material-ui/core/styles";
import QuoteyAdminNavigation from "../general/QuoteyAdminNavigation";
import BrokerageSuperAdminDashboard from "../quoteyadmin/BrokerageSuperAdminDashboard";
import BrokerageInsurerAdminDashboard from "../quoteyadmin/BrokerageInsurerAdminDashboard";
import BrokerageSuperAdminDetails from "../brokeragesuperadmin/BrokerageSuperAdminDetails";
import BrokerageSuperAdminPaymentDetails from "../brokeragesuperadmin/BrokerageSuperAdminPaymentDetails";
import BrokerageSuperAdminReports from "../brokeragesuperadmin/BrokerageSuperAdminReports";
import BrokerageSuperAdminUserManagement from "../brokeragesuperadmin/BrokerageSuperAdminUserManagement";
import BrokerageSuperAdminBMS from "../brokeragesuperadmin/BrokerageSuperAdminBMS";
import BrokerageSuperAdminCustomizeAPI from "../brokeragesuperadmin/BrokerageSuperAdminCustomizeAPI";
import BrokerageSuperAdminLogoAndColor from "../brokeragesuperadmin/BrokerageSuperAdminLogoAndColor";
import BrokerageSuperAdminUserData from "../brokeragesuperadmin/BrokerageSuperAdminUserData";
import BrokerageSuperAdminInsurers from "../brokeragesuperadmin/BrokerageSuperAdminInsurers";
//import BrokerageSuperAdminOperations from "../brokeragesuperadmin/BrokerageSuperAdminOperations";
import InsurerAdminDefaults from "../insureradmin/InsurerAdminDefaults";
import InsurerAdminLogo from "../insureradmin/InsurerAdminLogo";
import InsurerAdminData from "../insureradmin/InsurerAdminData";
import InsurerAdminAppetite from "../insureradmin/InsurerAdminAppetite";
import InsurerAdminBrokerageList from "../insureradmin/InsurerAdminBrokerageList";
import BrokerageSuperAdminAboutUs from "../brokeragesuperadmin/BrokerageSuperAdminAboutUs";
import CategoryManagement from "../brokerageadmin/CategoryManagement";
import PaymentProvider from "../brokerageadmin/paymentprovider/PaymentProvider";
import PaymentDetails from "../brokerageadmin/paymentprovider/PaymentDetails";
import BrokerageIpfsDetails from "../brokerageadmin/brokerageIpfsDetails";
import InsurerCode from "../brokerageadmin/insurercodedetails/InsurerCode";

import CustomBindDashboard from "./CustomPdfs/CustomBindDashboard";
import WhatsNewDashboard from "./WhatsNewModal/WhatsNewDashboard";
import QuoteyDashboard from "../brokerageadmin/QuoteyDashboard/QuoteyDashboard";


function ActiveTab(props, code) {
  //let view = true //props.match?.params?.view;
  const { view } = useParams();

  if (view === "details") {
    return <BrokerageSuperAdminDetails brokerageCode={code} />;
  } else if (view === "insurervisibility") {
    return <BrokerageSuperAdminInsurers brokerageCode={code} />;
  } else if (view === "branding") {
    return <BrokerageSuperAdminLogoAndColor brokerageCode={code} />;
  } else if (view === "aboutus") {
    return <BrokerageSuperAdminAboutUs brokerageCode={code} />;
  } else if (view === "apistatus") {
    return <BrokerageSuperAdminCustomizeAPI brokerageCode={code} />;
  } else if (view === "user") {
    return <BrokerageSuperAdminUserManagement brokerageCode={code} />;
  } else if (view === "paymentdetails") {
    return <BrokerageSuperAdminPaymentDetails brokerageCode={code} />;
  } else if (view === "userdata") {
    return <BrokerageSuperAdminUserData brokerageCode={code} />;
  } else if (view === "insurer") {
    return <BrokerageInsurerAdminDashboard />;
  } else if (view === "insurercontacts") {
    return <InsurerAdminDefaults brokerageCode={code} />;
  } else if (view === "logoandcolor") {
    return <InsurerAdminLogo insurerCode={code} />;
  } else if (view === "insurerappetite") {
    return <InsurerAdminAppetite insurerCode={code} />;
  } else if (view === "brokeragelist") {
    return <InsurerAdminBrokerageList insurerCode={code} />;
  } else if (view === "whatsNew") {
    return <WhatsNewDashboard />;
  } else if (view === "insurerdata") {
    return <InsurerAdminData insurerCode={code} />;
  } else if (view === "customBind") {
    return <CustomBindDashboard />;
  } else if (view === "reports") {
    return <BrokerageSuperAdminReports brokerageCode={code} />;
  } else if (view === "category") {
    return <CategoryManagement />;
  } else if (view === "paymentprovider") {
    return <PaymentProvider insurerCode={code} />;
  } else if (view === "payment-details") {
    return <PaymentDetails />;
  } else if (view === "ipfsDetail") {
    return <BrokerageIpfsDetails insurerCode={code} />;
  } else if (view === "insurer-details") {
    return <InsurerCode />;
  }else if (view === "quoteyDashboard") {
    return <QuoteyDashboard />;
  }
   else if (view === "bms") {
    return <BrokerageSuperAdminBMS brokerageCode={code} />;
  } else if (view === "quoteyDashboard") {
    return <QuoteyDashboard />;
  } else {
    return <BrokerageSuperAdminDashboard />;
  }
}

const QuoteyAdmin = (props) => {
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const search = useLocation().search;
  var code = new URLSearchParams(search).get("c");
  const { view } = useParams();

  const curTab = ActiveTab(props, code);

  useEffect(() => {
    dispatch(verifyToken());
  }, [dispatch]);

  return (
    <div>
      {broker.istokenvalid & broker.issuperadmin ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            paddingBottom: "50px",
            overflow: "hidden",
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
        >
          <GeneralAuthentication>
            <BrokerAdminPanel
              style={{ overflow: "hidden" }}
              leftPane={curTab ? curTab : <WelcomeBackRightPane />}
              rightPane={
                <PerfectScrollbar>
                  <QuoteyAdminNavigation active={view} brokerage={code} />
                </PerfectScrollbar>
              }
              leftPaneWidth={"85%"}
              rightPaneWidth={"15%"}
            />
          </GeneralAuthentication>
        </div>
      ) : (
        <GeneralAuthentication>
          <h1>Error: Access Denied</h1>
        </GeneralAuthentication>
      )}
    </div>
  );
};

const BrokerAdminPanel = (props) => {
  let leftPanel = props.leftPane ? props.leftPane : <div></div>;
  let rightPane = props.rightPane ? props.rightPane : <div></div>;

  let leftPaneWidth = props.leftPaneWidth
    ? props.leftPaneWidth
    : theme.SCALES.quotesLeftPaneWidth;
  let rightPaneWidth = props.rightPaneWidth
    ? props.rightPaneWidth
    : theme.SCALES.quotesRightPaneWidth;

  return (
    <div style={{ display: "flex", height: "100%", width: "100%" }}>
      <div
        style={{
          width: leftPaneWidth,
          height: "100%",
          backgroundColor: theme.COLORS.tertiary_lightbackground,
          boxShadow: "20px 20px 30px 0px #AFB6CC",
          zIndex: 2,
        }}
      >
        <BrokerAdminLeftPane leftPane={leftPanel} />
      </div>
      <div
        style={{
          width: rightPaneWidth,
          height: "100%",
          zIndex: 1,
          backgroundColor: theme.COLORS.tertiary_ligthindigo,
        }}
      >
        {rightPane}
      </div>
    </div>
  );
};

const BrokerAdminLeftPane = (props) => {
  let leftPane = props.leftPane ? props.leftPane : <div></div>;

  const [items, setItems] = useState({
    name: "Your Name",
    status: "Idle",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);

  const brokerages = useSelector(getBrokeragesList);
  const selectedBrokerage = useSelector(getSelectedBrokerage);

  const useStyles = makeStyles({
    responses: {
      "&::-webkit-scrollbar": {
        width: theme.SCALES.scrollbarThickness,
        backgroundColor: "inherit",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.COLORS.little_darker_lightindigo,
        borderRadius: 10,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.COLORS.primary_navyblue,
        borderRadius: 10,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: theme.COLORS.primary_navyblue,
      },
    },
  });

  const classes = useStyles();

  // On operation selected
  const onChangeHandle = (value) => {
    dispatch(brokerageSelected(value[0].code));
    const reRender = () => {
      setItems((state) => [...state]);
    };
  };

  const commonStyleForTableBox = {
    border: "5px solid white",
    borderRadius: 10,
    backgroundColor: theme.COLORS.help_tip,
    // width: "100%",
    boxShadow: "0px 0 30px 0px #AFB6CC",
    paddingLeft: 20,
    paddingRight: 20,
  };

  return (
    <div style={{ width: "100%", height: "94vh" }}>
      <PerfectScrollbar>
        <div style={{ margin: "50px" }}></div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "15%",
            paddingRight: "15%",
          }}
        >
          {}
          <div
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.5vw",
              color: theme.COLORS.primary_navyblue,
              display: "flex",
            }}
          >
            Jump into the driving seat and administer Quotey!
          </div>
          <br />
          <div
            style={{
              fontFamily: "GibsonRegular",
              fontSize: "1vw",
              color: theme.COLORS.primary_navyblue,
              display: "flex",
            }}
          >
            Select an option below
          </div>
          <br />
        </div>
        <div
          style={{
            marginLeft: "10%",
            marginRight: "10%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            ...commonStyleForTableBox,
          }}
        >
          {leftPane}
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default QuoteyAdmin;
